import type { StateCreator } from 'zustand';

import { group, identify } from '../../services/analytics';
import { USER_INFO } from '../../utils/constants/localStorage';
import { getLocalStorageObject, setLocalStorageObject } from '../../utils/functions/localStorage';
import type { GlobalStore, UserSlice, UserState } from '../schema';

export const createUserSlice: StateCreator<
  GlobalStore,
  [['zustand/devtools', never]],
  [],
  UserSlice
> = (set, get) => ({
  user: getLocalStorageObject(USER_INFO) as UserState,
  setUser: (user) => {
    setLocalStorageObject(USER_INFO, user);
    if (user?.email) {
      identify(`${user.email}`, user as Record<string, unknown>);
      if (user.company) {
        group('company', { name: user.company });
      }
    }
    set({ user }, false, 'user/set');
  },
  updateUser: (updates) => {
    const current = get().user;
    if (!current) return;
    const next = { ...current, ...updates };
    setLocalStorageObject(USER_INFO, next);
    set({ user: next }, false, 'user/update');
  },
  redirectionUrl: '/',
  setRedirectionUrl: (url) => set({ redirectionUrl: url }, false, 'user/setRedirectionUrl'),
});
